import { createContext } from 'react';
import { CarePlusAuthenticationState } from '@src/@types/auth';

export type AuthenticationStateContextShape = {
  id?: string;
  authenticationState?: CarePlusAuthenticationState;
};
export const AuthenticationStateContext =
  createContext<AuthenticationStateContextShape>({
    authenticationState: CarePlusAuthenticationState.ANONYMOUS,
  } as AuthenticationStateContextShape);
